import { NgModule } from '@angular/core';
import { MacAddressPipe } from './mac-address.pipe';

@NgModule({
   declarations: [MacAddressPipe],
   exports: [MacAddressPipe],
})
export class MacAddressPipeModule {}
